var alignmentStyle = {"alignLeft":"DCJhE","textWrapNowrap":"G2PG-","alignRight":"bLiho","alignCenter":"u7gr1","sizeFullWidth":"DPWYN","renderedInTable":"v-PWC","sizeOriginal":"_7GRc4","sizeContent":"_5fSZu","sizeSmall":"tVwav","sizeSmallCenter":"hY-9z","flex":"kc82-","LEFT":"AvvJx","CENTER":"yHnvZ","RIGHT":"vrJKw","AUTO":"KNByY","JUSTIFY":"g9g8z"};

export { alignmentStyle as a };
//# sourceMappingURL=alignment.rtlignore-bc42ede7.js.map
